import React from 'react';

const LoadingList = ({ loadingConfigs }) => {
  return (
    <div className="w-full md:w-[80%] m-auto py-14">
      <div
        className={`grid grid-cols-${loadingConfigs?.colItem?.sm} w-[80%] md:w-full md:grid-cols-${loadingConfigs?.colItem?.md} mx-auto lg:grid-cols-${loadingConfigs?.colItem?.lg} gap-6`}
      >
        {Array(loadingConfigs?.totalItem || 6)
          .fill(0)
          .map(() => loadingConfigs?.renderItem)}
      </div>
      <div className="h-8 bg-gray-200 w-1/2 mt-8 m-auto" />
    </div>
  );
};

export default LoadingList;
